// Shared neutral loading state for any route that must wait on Firebase auth
// resolution before deciding what to render. Deliberately renders neither
// the authenticated app chrome nor any public/marketing surface — used by
// `ProtectedRoute` and by the `/` root route (EPIC-38) so a signed-in user
// never sees a flash of marketing content, and an unauthenticated user never
// sees a flash of protected app chrome, while `authStore.loading` is true.
export default function AuthLoadingScreen() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      data-testid="auth-loading-screen"
    >
      <div role="status">
        <div className="spinner"></div>
        <span className="sr-only">Loading</span>
      </div>
    </div>
  );
}
